import styled from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const Container = styled.div`
  display: grid;
  grid-gap: 57.5px;
  justify-content: center;
  align-content: center;
  height: 492px;
  padding: 0px 20px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.7) 100%), url('${(
    props,
  ) => props.$img}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const Title = styled.div`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: ${colors.WHITE};
  max-width: calc(100vw - 40px);
  justify-self: center;
  overflow-wrap: break-word;
  word-wrap: break-word;

  ${MediaQuery.small`
    font-style: normal;
    font-weight: 500;
    font-size: 52px;
    line-height: 63px;
  `}
`;

export const BodyContainer = styled.div`
  max-width 662px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 65px 1fr;
  grid-template-areas:
    ". . ."
    "track track track";
`;

export const TabContainer = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 2px;

  &:nth-child(1) {
    display: flex;
    justify-content: flex-end;
  }

  &:nth-child(3) {
    display: flex;
    justify-content: flex-start;
  }
`;

export const Tab = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-auto-flow: column;
  align-items: center;
  padding: 16.5px 26px 20px;
  cursor: pointer;

  &:nth-child(2) {
    max-width: 137px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-top: 3px solid ${colors.BRAND_ORANGE};
    border-bottom: none;
    border-radius: 2px;
  }

  img{
    min-width: 24px;
  }
`;

export const TabText = styled.div`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: ${colors.WHITE};

  ${MediaQuery.small`
    font-size: 18px;
    line-height: 27px;
  `}
`;

export const Form = styled.form`
  width: 100%;
  display: grid;
  justify-items: center;
  grid-gap: 12px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-top: 0px;
  border-radius: 1px;
  grid-area: track;

  ${MediaQuery.small`
    grid-auto-flow: column;
    padding: 27px 31px 22px 27px;
    grid-template-columns: auto 157px;
  `}

  input {
    width: 100%;
    height: 56px;
    padding: 12px 24px;
    border: 1px solid ${colors.COOL_GREY};
    border-radius: 1px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    outline: 0;
    color: ${colors.BLACK};
  }

  .error {
    border: 2px solid ${colors.ERROR};
  }

  button {
    height: 56px;
    width: 100%;

    .children {
      flex: unset;
    }
  }
`;

export const FieldWrapper = styled.div`
  width: 100%;

  span {
    color: ${colors.WHITE};
  }
`;
